import { useState } from 'react';
import { isAxiosError } from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from '../ui/button.tsx';
import { Input } from '../ui/input.tsx';
import { Label } from '../ui/label.tsx';
import { Card, CardContent, CardHeader } from '../ui/card.tsx';
import { useAuth } from '../../hook_au/useAuth.tsx';
import apiClient from '../../services/apiClient.ts';

const LOGO_SRC = '/assets/interiorlab-logo.png';

export function Login() {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    if (isSubmitting) return;

    setErrorMessage(null);
    setIsSubmitting(true);

    try {
      const response = await apiClient.post('/auth/login', { email, password });
      const { access_token: accessToken, user } = response.data;

      setSession({ token: accessToken, user });
      const landingPath = user?.role === 'logistica' ? '/orders' : '/dashboard';
      navigate(landingPath, { replace: true });
    } catch (error) {
      if (isAxiosError(error) && error.response?.status === 401) {
        setErrorMessage('Credenciales incorrectas. Revisa tu email y contraseña.');
      } else {
        setErrorMessage('No pudimos iniciar sesión. Inténtalo de nuevo más tarde.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader className="text-center">
          <div className="flex flex-col items-center justify-center min-h-[140px]">
            <img src={LOGO_SRC} alt="Logo interiørlab" className="h-18 w-auto mx-auto mb-2" />
          </div>
        </CardHeader>

        <CardContent className="pb-8">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Usuario</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="Ingresa tu usuario"
                className="mt-1"
                required
              />
            </div>

            <div>
              <Label htmlFor="password">Contraseña</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="Ingresa tu contraseña"
                className="mt-1"
                required
              />
            </div>

            {errorMessage && (
              <p className="text-red-600 text-sm" role="alert">
                {errorMessage}
              </p>
            )}

            <Button type="submit" className="w-full mt-6 bg-blue-600 hover:bg-blue-700">
              Iniciar sesión
            </Button>
            <Link to="/forgot-password">¿Olvidaste tu contraseña?</Link>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
